export default __webpack_public_path__ + "static/media/__downloads_icon.2125339d.svg";